import { Button, Col, Row, Tooltip } from "antd";
import "ckeditor5/ckeditor5-content.css";
import "ckeditor5/ckeditor5.css";
import moment from "moment";
import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { BsFillSendFill, BsSave, BsTrash3Fill } from "react-icons/bs";
import {
  IoIosEyeOff,
  IoMdArrowDropdown,
  IoMdArrowDropright,
  IoMdClose,
  IoMdDownload,
} from "react-icons/io";
import { MdFilePresent } from "react-icons/md";
import { v4 as uuidv4 } from "uuid";
import apiFactory from "../../../api";
import { CustomAvatar } from "../../../components/avatar/CustomAvatar";
import { DraftMessageComponent } from "../../../components/chat/DraftMessageComponent";
import FileHandlerWrapper from "../../../components/mail/FileHandlerWrapper";

import { ForwardMailModal } from "../../../components/modal/ForwardMailModal";
import { GeneralModal } from "../../../components/modal/GeneralModal";
import { PreviewFileUploadModal } from "../../../components/modal/PreviewFileUploadModal";
import { MailFilesPreview } from "../../../components/preview/MailFilesPreview";
import EmailComposer from "../../../components/richTextEditor/EmailComposer";
import { conversationType } from "../../../config/Constant";
import { useMailContext } from "../../../context/MailContext";
import { useMenuContext } from "../../../context/MenuContext";
import { useInfoUser } from "../../../store/UserStore";
import { formatTime } from "../../../utils/formatTime";
import { useGlobalDownloader } from '../../../context/global/DownloadProvider';
import { RESOURCE_API } from "../../../api/apiConstant";
import MailStorageFile from "../../../components/preview/MailStorageFile";
import {
  blobToBase64,
  convertOembedToIframe,
  convertToUrl,
  extractEditorResourceIds,
  getPlainTextFromHtml,
  openNotificationError,
} from "../../../utils/Utils";
import "./style.scss";

const ShowFile = ({ notification }) => {
  const createdAt = notification?.createdAt;
  const resources = notification?.resources || notification?.files || [];
  const [pickedList, setPickedList] = useState([]);

  const { startDownloadCompress } = useGlobalDownloader();

  const pickFile = (resourceId) => {
    if (!resourceId) return;

    if (pickedList.includes(resourceId)) {
      setPickedList(pickedList.filter((id) => id !== resourceId));
    } else {
      setPickedList([...pickedList, resourceId]);
    }
  };

  const handleDownload = (e) => {
    e.stopPropagation();
    startDownloadCompress(pickedList, "willo.zip");
  };

  return (
    <div>
      {pickedList?.length > 0 ? (
        <div className="flex gap-[20px] ml-[50px] mb-[5px] bg-[#f0f4f9] p-[5px] rounded-[10px]">
          <button onClick={() => setPickedList([])}>
            <IoMdClose className="text-[18px] text-[#2b9853]" />
          </button>
          <div>{pickedList?.length} selected </div>
          <button onClick={handleDownload}>
            <IoMdDownload className="text-[20px] text-[#2b9853]" />
          </button>
        </div>
      ) : (
        <div className="h-[36px]"></div>
      )}
      {resources?.length > 0 && (
        <Row className="ml-[37px] mb-2">
          {resources?.map((item) => {
            const fileWithTimestamp = {
              ...item,
              createdAt,
            };

            return (
              <Col
                className="flex justify-center"
                key={item?.resourceId}
                xs={24}
                sm={24}
                md={24}
                lg={12}
                xl={12}
                xxl={6}
              >
                <MailStorageFile
                  file={fileWithTimestamp}
                  pickFile={pickFile}
                  pickedList={pickedList}
                  setPickedList={setPickedList}
                  key={item?.resourceId}
                />
              </Col>
            );
          })}
        </Row>
      )}
    </div>
  );
};

const MailReply = forwardRef(
  (
    {
      notification,
      isLastItem,
      isTopMessage,
      setIsReplyAll,
      addMemberOrg,
      setSelectedMessage,
      setIsModalMembersReadUnread,
      onDirtyChange,
      listMember,
      totalMember,
      ccList,
      totalCC,
      onSentSuccess,
    },
    ref
  ) => {
    const [mailContent, setMailContent] = useState({
      content: "",
      oldContent: "",
    });
    const [isReply, setIsReply] = useState(false);
    const [isForwardMail, setIsForwardMail] = useState(false);
    const {
      selectedConversation,
      handleUpdateConversationList,
      handleChangeConversation,
      onBackToConversations,
      conversationList,
    } = useMenuContext();
    const { userList, title, setIsLoading, isLoading } = useMailContext();
    const { user } = useInfoUser();
    const replyDivRef = useRef(null);
    const { languageMap } = useInfoUser();
    const [isOpenModalConfirmation, setIsOpenModalConfirmation] =
      useState(false);
    const [isDeleteMailDraft, setIsDeleteMailDraft] = useState(false);
    const [processedContent, setProcessedContent] = useState("");
    const [previewFiles, setPreviewFiles] = useState([]);
    const [uploadFiles, setUploadFiles] = useState([]);
    const [isOpenOut, setIsOpenOut] = useState(true);
    const [isOpenUploadModal, setIsOpenUploadModal] = useState(false);
    const [forwardTitle, setForwardTitle] = useState("");
    const {
      topMessageList,
      setTotalNotificationItem,
      bottomMessageList,
      setBottomMessageList,
      setTopMessageList,
    } = useMailContext();

    const clearAllBeforeEvent = () => {
      setMailContent({ content: "", oldContent: "" });
      setPreviewFiles([]);
      setUploadFiles([]);
      setIsReply(false);
      setIsLoading(false);
    };

    const changeOpenUp = () => {
      setIsOpenOut(!isOpenOut);
    };

    const createNotification = async () => {
      if (!validateSendMail(true)) return;
      const { userIds, ccIds } = addMemberOrg();

      if (
        !selectedConversation?.conversationId ||
        selectedConversation?.type === conversationType.DRAFT ||
        isForwardMail
      ) {
        if (!userIds || userIds?.length === 0) {
          openNotificationError(
            languageMap
              ? languageMap["error.chosenRecipient"]
              : "You haven't chosen recipient"
          );

          setIsLoading(false);
          return;
        }
      }

      const params = {
        name: isForwardMail ? forwardTitle : title,
        userIds,
        ccIds,
        conversationType: conversationType.NOTIFICATION,
        conversationId: isForwardMail
          ? null
          : selectedConversation?.conversationId || null,
      };

      try {
        const result = await apiFactory.conversationApi.createMailGroup(params);

        if (result.status !== 200) {
          openNotificationError(languageMap?.[result?.message]);
        } else {
          const conversationRes = result?.data;
          await sendMail(conversationRes?.conversationId);
          onCreateNotificationSuccessfully(conversationRes);
        }
      } catch (error) {
      } finally {
        clearAllBeforeEvent();
      }
    };

    const onCreateNotificationSuccessfully = (conversation) => {
      handleChangeConversation(conversation);
    };

    const validateSendMail = (isNoti) => {
      if (
        mailContent?.content?.trim()?.length === 0 &&
        previewFiles?.length === 0
      ) {
        if (isNoti) {
          openNotificationError(
            languageMap?.["error.mailHaveContent"] ??
              "You have to input email content"
          );
        }

        setIsLoading(false);
        return false;
      }

      return true;
    };

    const processHtmlForSaving = (htmlContent) => {
      if (!htmlContent) return "";

      const doc = new DOMParser().parseFromString(htmlContent, "text/html");

      const figures = Array.from(
        doc.querySelectorAll("figure[data-resource-id]")
      );

      figures.forEach((figureDoc) => {
        const resourceId = figureDoc.getAttribute("data-resource-id");

        if (resourceId) {
          const imgDoc = figureDoc.querySelector("img");
          if (!imgDoc) return;

          const apiUrl = `${process.env.REACT_APP_AUTHENTICATION_API_URL}/${RESOURCE_API}/free/file/${resourceId}`;

          imgDoc.src = apiUrl;

          figureDoc.removeAttribute("data-resource-id");
        }
      });

      const otherImages = Array.from(doc.querySelectorAll("img"));
      otherImages.forEach((imgDoc) => {
        if (
          isBase64(imgDoc.src) &&
          !imgDoc.closest("figure[data-resource-id]")
        ) {
          const resourceId = imgDoc.getAttribute("data-resource-id");

          if (!imgDoc) return;

          const apiUrl = `${process.env.REACT_APP_AUTHENTICATION_API_URL}/${RESOURCE_API}/free/file/${resourceId}`;

          imgDoc.src = apiUrl;

          imgDoc.removeAttribute("data-resource-id");
        }
      });

      return doc.body.innerHTML;
    };

    const sendMail = async (creatingConversationId) => {
      if (!validateSendMail(true)) return;

      const requestUuid = uuidv4();
      const isAllCondition =
        !notification?.recipientId ||
        (notification?.recipientId === "ALL" &&
          notification?.senderId === user?.userId);

      const recipientId =
        isForwardMail || isAllCondition
          ? "ALL"
          : notification?.senderId === user?.userId
            ? notification?.recipientId
            : notification?.senderId;

      const conversationId =
        notification?.conversationId && !isForwardMail
          ? notification.conversationId
          : creatingConversationId;

      const allEditorResourceIds = extractEditorResourceIds(
        mailContent?.content
      );

      const params = {
        requestUuid,
        conversationId,
        senderId: user?.userId,
        recipientId,
        content: processHtmlForSaving(mailContent?.content),
        isDraft: false,
        files: previewFiles || [],
        updatedMediaConversationId: true,
        draftMailId: notification?.draftMail?.draftMailId,
        mailId: !isForwardMail && notification?.mailId,
        editorResourceId: allEditorResourceIds,
        plainText: getPlainTextFromHtml(mailContent?.content),
        isForwardMail: isForwardMail,
      };

      try {
        const rs = await apiFactory.mailApi.sendMessage(params);

        if (rs && rs.status !== 200) {
          openNotificationError("Create mail unsuccessfully");
          return;
        }

        const message = {
          ...params,
          draftMail: null,
          isDraft: false,
          isSelf: true,
          updatedAt: moment(),
          createdAt: moment(),
        };

        setTotalNotificationItem((prev) => prev + 1);
        onDirtyChange(false);

        updateMessage(message);
      } catch (error) {
      } finally {
        clearAllBeforeEvent();
      }
    };

    const sendNotification = async () => {
      setIsLoading(true);

      if (isForwardMail) {
        await createNotification();
      } else {
        await sendMail();
        onSentSuccess?.();
      }
    };

    const getName = useCallback(
      (id) => {
        if (id === "ALL") {
          return languageMap?.["modal.notification.replyAll"] ?? "all";
        } else {
          return userList?.find((s) => s.userId === id)?.name;
        }
      },
      [userList, languageMap]
    );

    const getMemberText = useCallback(
      (listMember = [], ccList = [], id) => {
        const andText = languageMap?.["modal.notification.andText"] ?? "và";
        const othersText =
          languageMap?.["modal.notification.othersText"] ?? "người khác";

        const mergedUsers = [
          ...(listMember || []),
          ...(ccList || []),
          ...(userList || []),
        ];

        const uniqueUsers = Array.from(
          new Map(mergedUsers.map((u) => [u.userId, u])).values()
        );

        if (!uniqueUsers.length) {
          return userList?.find((u) => u.userId === user?.userId)?.name ?? "";
        }

        if (id === "ALL") {
          const otherUsers = uniqueUsers.filter(
            (u) => u.userId !== user?.userId
          );

          if (otherUsers.length === 1) {
            return otherUsers[0].name;
          }

          if (otherUsers.length === 0) {
            return userList?.find((u) => u.userId === user?.userId)?.name ?? "";
          }

          const firstName = otherUsers[0]?.name;
          const othersCount = otherUsers.length - 1;

          if (othersCount <= 0) return firstName;

          return `${firstName} ${andText} ${othersCount} ${othersText}`;
        }

        return uniqueUsers.find((u) => u.userId === id)?.name ?? "";
      },
      [userList, languageMap, totalMember, totalCC, user?.userId]
    );

    const isBase64 = (str) => {
      return str.startsWith("data:image/") && str.includes(";base64");
    };

    const replyingTo = useMemo(() => {
      if (
        !notification &&
        !(notification?.senderId || notification?.recipientId)
      ) {
        return "";
      }

      if (!notification?.senderId || notification?.senderId === user?.userId) {
        return notification?.recipientId === "ALL"
          ? getMemberText(listMember, ccList, "ALL")
          : notification?.recipientId
            ? getMemberText(listMember, ccList, notification?.recipientId)
            : getMemberText(listMember, ccList, "ALL");
      } else {
        return notification?.senderId
          ? userList?.find((s) => s.userId === notification?.senderId)?.name
          : getMemberText(listMember, ccList, "ALL");
      }
    }, [notification, user?.userId, languageMap, userList]);

    const getSender = () => {
      return userList?.find((s) => s?.userId === notification?.senderId);
    };

    const getPosition = () => {
      if (replyDivRef.current) {
        replyDivRef.current.scrollIntoView({
          block: "center",
          behavior: "instant",
        });
      }
    };

    const getIconNotification = (notification) => {
      if (!notification?.files?.length) return;

      return (
        <div className="text-[#5e5e5e] justify-end items-end">
          <MdFilePresent size={20} color={"#3269c9"} />
        </div>
      );
    };

    const GetIconUnread = ({ notification, onClick }) => {
      if (notification?.oldConversationId) return null;

      return (
        <Button
          className="bg-[#2a56b9] text-white h-[20px] gap-[4px] zoom-09 flex items-center"
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onClick?.(e);
          }}
        >
          <IoIosEyeOff size={12} />
          <span className="text-[12px]">{notification?.unreadCount}</span>
        </Button>
      );
    };

    const showOpenDownArrow = useMemo(() => {
      return (
        <div
          onClick={changeOpenUp}
          onMouseDown={(e) => {
            e.preventDefault();
          }}
          className="cursor-pointer"
        >
          {isOpenOut ? (
            <Tooltip
              placement="top"
              title={languageMap?.["modal.message.showLess"] ?? "show less"}
              color={"#0091ff"}
            >
              <IoMdArrowDropdown size={20} color="black" />
            </Tooltip>
          ) : (
            <Tooltip
              placement="top"
              title={languageMap?.["modal.message.showMore"] ?? "show more"}
              color={"#0091ff"}
            >
              <IoMdArrowDropright size={20} color="black" />
            </Tooltip>
          )}
        </div>
      );
    }, [isOpenOut]);

    const handleDeleteMailDraft = async () => {
      const { conversationId, draftMail } = notification || {};
      const draftMailId = draftMail?.draftMailId;

      if (!conversationId || !draftMailId) {
        setIsDeleteMailDraft(false);
        return;
      }

      try {
        const rs = await apiFactory.draftMessageApi.delete({
          conversationId,
          draftMailId,
          type: conversationType.DRAFT,
        });

        if (rs?.status !== 200) {
          openNotificationError("Delete Mail Draft Fail!");
          return;
        }

        const newConvs = conversationList.filter(
          (c) => c?.conversationId !== selectedConversation?.conversationId
        );

        handleUpdateConversationList(newConvs);

        onBackToConversations();
      } catch (error) {
        openNotificationError("Delete Mail Draft Error!");
        console.error(error);
      } finally {
        setIsDeleteMailDraft(false);
      }
    };

    const handleCloseReply = async () => {
      if (validateSendMail(false)) {
        setIsOpenModalConfirmation(true);
      } else {
        await deleteDraftMessage();

        clearAllBeforeEvent();
      }
    };

    const handleSaveOrUpdateDraftMessage = async () => {
      if (!mailContent?.content && previewFiles?.length === 0) return;

      const selectedConversationId = notification?.conversationId;

      const req = {
        conversationId: selectedConversationId,
        mailId: notification?.mailId,
        content: mailContent?.content,
        recipientId: notification?.recipientId || null,
        files: previewFiles || [],
        requestUuid: uuidv4(),
        updatedMediaConversationId: false,
      };

      const draftMessage = await apiFactory.draftMessageApi.createOrUpdate(req);

      if (draftMessage && draftMessage.status === 200 && draftMessage.data) {
        setIsReply(false);
        onDirtyChange(false);
        updateDraftMessage(draftMessage?.data);
      } else {
        openNotificationError("Save or update draft messages failed");
      }
    };

    useImperativeHandle(ref, () => ({
      saveDraft: handleSaveOrUpdateDraftMessage,
    }));

    const extractImageIds = (htmlString) => {
      if (!htmlString) return [];
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, "text/html");

      const elements = doc.querySelectorAll("[data-resource-id]");

      const ids = Array.from(elements)
        .map((el) => {
          return el.getAttribute("data-resource-id");
        })
        .filter((id) => id);

      return [...new Set(ids)];
    };

    const deleteDraftMessage = async () => {
      if (
        !isTopMessage &&
        (!notification ||
          !notification.draftMail ||
          !notification.draftMail.draftMailId)
      )
        return;

      if (notification?.draftMail?.draftMailId) {
        const rs = await apiFactory.draftMessageApi.delete({
          conversationId: notification?.conversationId,
          draftMailId: notification?.draftMail?.draftMailId,
          mailId: notification?.mailId,
        });

        if (rs?.status !== 200) {
          openNotificationError("Delete draft messages failed");
          return;
        }
      }
      updateMessage(null);
    };

    const handleDeleteImageEditor = async () => {
      const deletedIds = extractImageIds(mailContent?.content);

      await apiFactory.resourceApi
        .deleteFiles({
          resourceIds: deletedIds,
          conversationId: notification?.conversationId,
        })
        .catch((err) => console.error("Failed to delete files", err));
    };

    const handleConfirmCloseReply = async () => {
      setIsReply(false);
      setIsOpenModalConfirmation(false);
      await handleDeleteImageEditor();
      await deleteDraftMessage();
      clearAllBeforeEvent();
    };

    const updateDraftMessageOnTop = (data) => {
      if (!topMessageList?.length) return false;

      const index = topMessageList?.findIndex(
        (msg) => msg?.requestUuid === notification?.requestUuid
      );

      if (index === -1) return false;

      topMessageList[index].mailId = data?.mailId;
      topMessageList[index].isEditing = false;
      topMessageList[index].draftMail = data;
      setTopMessageList([...topMessageList]);

      return true;
    };

    const updateDraftMessageOnBottom = (data) => {
      if (!bottomMessageList?.length) return;

      const index = bottomMessageList?.findIndex(
        (msg) => msg?.requestUuid === notification?.requestUuid
      );

      if (index !== -1) {
        bottomMessageList[index].mailId = data?.mailId;
        bottomMessageList[index].isEditing = false;
        bottomMessageList[index].draftMail = data;
        setBottomMessageList([...bottomMessageList]);
      }
    };

    const updateDraftMessage = (data) => {
      const updateTop = updateDraftMessageOnTop(data);
      if (!updateTop) updateDraftMessageOnBottom(data);
    };

    const updateMessageOnTop = () => {
      if (!topMessageList) return;

      const index = topMessageList?.findIndex(
        (msg) => msg?.requestUuid === notification?.requestUuid
      );

      if (index === -1) return;

      if (topMessageList?.[index]?.isDraft) {
        topMessageList?.splice(0, 1);
        setTopMessageList([...topMessageList]);
      } else {
        topMessageList[index].draftMail = null;
        setTopMessageList([...topMessageList]);
      }
    };

    const updateMessageOnBottom = (data) => {
      if (!bottomMessageList) return;

      const index = bottomMessageList?.findIndex(
        (msg) => msg?.requestUuid === notification?.requestUuid
      );

      if (index !== -1) {
        bottomMessageList[index].draftMail = null;
      }

      if (data) {
        setBottomMessageList([...bottomMessageList, data]);
      }
    };

    const updateMessage = (data) => {
      updateMessageOnTop(data);
      updateMessageOnBottom();
    };

    const closeDraftMessage = (isClose) => {
      let newMessageList = [];

      if (isTopMessage) {
        const index = topMessageList?.findIndex(
          (n) => n?.mailId === notification?.mailId
        );

        if (index !== -1) {
          newMessageList = topMessageList?.map((item, i) =>
            i === index
              ? {
                  ...item,
                  draftMail: {
                    ...item?.draftMail,
                    isClosed: isClose,
                  },
                }
              : item
          );
        } else {
          newMessageList = topMessageList;
        }

        setTopMessageList([...newMessageList]);
      } else {
        const index = bottomMessageList?.findIndex(
          (n) => n?.mailId === notification?.mailId
        );

        if (index !== -1) {
          newMessageList = bottomMessageList?.map((item, i) =>
            i === index
              ? {
                  ...item,
                  draftMail: {
                    ...item?.draftMail,
                    isClosed: isClose,
                  },
                }
              : item
          );
        } else {
          newMessageList = bottomMessageList;
        }

        setBottomMessageList([...newMessageList]);
      }
    };

    const convertedContent = useMemo(() => {
      let html = processedContent;

      html = convertOembedToIframe(html);
      html = convertToUrl(html);

      return html;
    }, [processedContent]);

    const handleCancelUpload = () => {
      setIsOpenUploadModal(false);
      setUploadFiles([]);
    };

    const cancelForward = () => {
      setIsForwardMail(false);
    };

    useEffect(() => {
      const processReceivedImages = async () => {
        let content = notification?.content;
        if (!content) {
          setProcessedContent("");
          return;
        }

        const doc = new DOMParser().parseFromString(content, "text/html");
        const images = Array.from(doc.querySelectorAll("img"));

        const imagePromises = images.map(async (imgDoc) => {
          if (!imgDoc?.src) return Promise.resolve();

          if (isBase64(imgDoc.src)) return Promise.resolve();

          if (!imgDoc.src.includes(RESOURCE_API)) {
            return Promise.resolve();
          }

          const parts = imgDoc.src.split("/");
          const resourceId = parts.pop();
          if (!resourceId || resourceId === "null") {
            return Promise.resolve();
          }

          try {
            const fetchedBlob =
              await apiFactory.resourceApi.getStreamFileAsBlob(resourceId);

            if (
              !fetchedBlob ||
              fetchedBlob.size === 0 ||
              fetchedBlob.type.startsWith("application/json")
            ) {
              imgDoc.remove();
              return;
            }

            const base64Data = await blobToBase64(fetchedBlob);

            imgDoc.src = base64Data;
          } catch (error) {
            console.error("Failed to load received image:", resourceId, error);
            imgDoc.remove();
          }
        });

        await Promise.all(imagePromises);

        setProcessedContent(doc.body.innerHTML);
      };

      processReceivedImages();
    }, [notification?.content]);

    useEffect(() => {
      setIsReply(notification?.isEditing);
    }, [notification?.isEditing]);

    useEffect(() => {
      if (isReply) {
        getPosition();
      }
    }, [isReply]);

    useEffect(() => {
      if (notification?.draftMail?.files) {
        setPreviewFiles((prev) => {
          const oldIds = prev?.map((f) => f?.resourceId) || [];
          const newFiles = notification?.draftMail?.files?.filter(
            (f) => !oldIds?.includes(f?.resourceId)
          );
          return [
            ...prev,
            ...newFiles.map((f) => ({ ...f, fileDraftOld: true })),
          ];
        });
      }
    }, [notification?.draftMail?.files]);

    useEffect(() => {
      if (convertedContent) {
        setIsOpenOut(isLastItem ?? false);
      }
    }, [convertedContent]);

    useEffect(() => {
      if (selectedConversation?.type === "DRAFT") {
        setMailContent({ content: "", oldContent: "" });
        setPreviewFiles(
          selectedConversation?.conversationId
            ? notification?.draftMail?.files.map((file) => ({
                ...file,
                fileDraftOld: true,
              }))
            : []
        );
        setUploadFiles([]);
      }
    }, [selectedConversation]);

    useEffect(() => {
      const dirty =
        (notification?.draftMail?.content !== mailContent?.content &&
          mailContent?.content !== mailContent?.oldContent) ||
        previewFiles?.some((f) => !f.fileDraftOld);

      onDirtyChange?.(dirty);
    }, [mailContent, previewFiles]);

    return (
      <div>
        {!notification?.isDraft && (
          <div key={notification?.notificationId}>
            <div
              className="flex justify-between cursor-pointer"
              onClick={changeOpenUp}
              onMouseDown={(e) => {
                e.preventDefault();
              }}
            >
              <div className="flex items-center gap-[6px] mb-2">
                <div onClick={(e) => e.stopPropagation()}>
                  <CustomAvatar
                    person={getSender()}
                    userId={getSender()?.userId}
                    styleCss={{}}
                    isShowDetail={true}
                    isShowUserStatus={{ status: true, isAlwaysTrue: false }}
                  />
                </div>

                <div className="mr-2">
                  <div className="text-[14px] flex items-center">
                    <div className="font-bold">
                      {getName(notification?.senderId)}
                    </div>
                    <div className="ml-2">{showOpenDownArrow}</div>
                  </div>

                  {user?.language !== "kr" ? (
                    <div className="text-[#5e5e5e] text-[12px] flex gap-[2px]">
                      <span>
                        {languageMap?.[`modal.notification.sentToText`] ??
                          " sent to "}
                      </span>
                      <span>
                        {getMemberText(
                          listMember,
                          ccList,
                          notification?.recipientId
                        )}
                      </span>
                    </div>
                  ) : (
                    <div className="text-[#5e5e5e] text-[12px]">
                      <span>
                        {getMemberText(
                          listMember,
                          ccList,
                          notification?.recipientId
                        )}
                      </span>
                      <span>
                        {languageMap?.[`modal.notification.sentToText`] ??
                          " sent to "}
                      </span>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex items-center gap-[10px] justify-center mr-[32px]">
                {getIconNotification(notification)}
                {selectedConversation?.unreadCount > 0 &&
                  (!selectedConversation?.lastSeenTs ||
                    selectedConversation?.lastSeenTs <
                      notification?.createdAt) && (
                    <div className="bg-[#188038] text-white h-[20px] gap-[4px] zoom-09 flex items-center justify-center rounded-full px-[8px]">
                      <span className="text-[12px]">new</span>
                    </div>
                  )}
                <GetIconUnread
                  notification={notification}
                  onClick={() => {
                    setIsModalMembersReadUnread(true);
                    setSelectedMessage(notification);
                  }}
                />
                <div className="text-[#5e5e5e]">
                  {formatTime(notification?.createdAt)}
                </div>
              </div>
            </div>
            <div className="ml-[37px] text-[15px] break-words custom-collapsible pb-[10px]">
              <div
                className="ck-content !h-auto"
                dangerouslySetInnerHTML={{
                  __html: convertedContent,
                }}
              />
            </div>
            <div
              style={{ display: isOpenOut && notification ? "block" : "none" }}
            >
              <ShowFile notification={notification} />
            </div>
          </div>
        )}

        {isForwardMail && (
          <ForwardMailModal
            notification={notification}
            isForwardMail={isForwardMail}
            setIsForwardMail={setIsForwardMail}
            addMemberOrg={addMemberOrg}
            cancelForward={cancelForward}
          />
        )}
        {!isReply &&
          notification?.draftMail?.draftMailId &&
          !notification?.isClosed && (
            <div className={`${!notification?.isDraft && "ml-5"}`}>
              <DraftMessageComponent
                draftMessage={notification?.draftMail}
                languageMap={languageMap}
                setIsReply={setIsReply}
                selectedConversation={selectedConversation}
                currentUser={user}
                isReplyAll={false}
              />
            </div>
          )}
        {isReply && (
          <FileHandlerWrapper
            className="mt-2"
            setUploadFiles={setUploadFiles}
            setIsOpenUploadModal={setIsOpenUploadModal}
            languageMap={languageMap}
            innerRef={replyDivRef}
          >
            {selectedConversation &&
              selectedConversation.type !== conversationType.DRAFT && (
                <div className="text-center mb-1">
                  {languageMap?.[`notification.reply.to`]}
                  {" " + replyingTo}
                </div>
              )}
            <EmailComposer
              originalContent=""
              setMailContent={setMailContent}
              mailContent={mailContent}
              conversationId={notification?.conversationId}
              index={notification?.mailId}
            />
            <div className="flex flex-col">
              <div className="flex gap-[10px]">
                <MailFilesPreview
                  previewFiles={previewFiles}
                  setPreviewFiles={setPreviewFiles}
                  setIsOpenUploadModal={setIsOpenUploadModal}
                  setUploadFiles={setUploadFiles}
                />
              </div>
              <div className="flex justify-end my-[5px]">
                <Tooltip placement="top" title={"Save draft"} color={"#0091ff"}>
                  <Button
                    className="bg-[#2a56b9] text-[white]"
                    onClick={handleSaveOrUpdateDraftMessage}
                    icon={<BsSave className="text-[18px]" />}
                  />
                </Tooltip>
                {selectedConversation?.conversationId && (
                  <Button
                    className="bg-[#2a56b9] text-white"
                    onClick={handleCloseReply}
                    icon={<BsTrash3Fill className="text-[18px]" color="red" />}
                  />
                )}
                <Button
                  className="bg-[#2a56b9] text-[white]"
                  onClick={sendNotification}
                  disabled={isLoading}
                  icon={
                    <BsFillSendFill className="text-[18px]" color="#30a3e6" />
                  }
                >
                  {languageMap?.["chat.mail.btn.send"] ?? "Send"}
                </Button>
              </div>
            </div>
          </FileHandlerWrapper>
        )}
        {isOpenModalConfirmation && (
          <GeneralModal
            title={languageMap?.["modal.reply.title"] ?? "Close reply"}
            content={
              languageMap?.["modal.reply.content"] ??
              "Closing the reply will discard your text. Do you want to continue?"
            }
            open={isOpenModalConfirmation}
            onConfirm={handleConfirmCloseReply}
            onCancel={() => setIsOpenModalConfirmation(false)}
          />
        )}

        {isDeleteMailDraft && (
          <GeneralModal
            title="Delete Mail Draft"
            content="Do you want delete mail draft?"
            open={isDeleteMailDraft}
            onConfirm={handleDeleteMailDraft}
            onCancel={() => setIsDeleteMailDraft(false)}
          />
        )}
        {isOpenUploadModal && (
          <PreviewFileUploadModal
            isModalOpen={isOpenUploadModal}
            handleCancel={handleCancelUpload}
            uploadFiles={uploadFiles}
            setUploadFiles={setUploadFiles}
            previewFiles={previewFiles}
            setPreviewFiles={setPreviewFiles}
          />
        )}
      </div>
    );
  }
);
export { MailReply };

